// Build-time launch flag. Mirrors the marketing-site config.ts APP_LIVE knob.
// Flip to true at monetize (Stripe go-live) and rebuild.
export const PAYMENTS_ENABLED = false
